<template>
  <v-container fluid>
    <div class="d-flex flex-column employee-detail-dashboard">
      <EmployeePageHeader
        v-if="isNewLayoutEnabled"
        :employeeData="employeeData"
        :loading="loading"
        @employee-updated="handleEmployeeUpdate"
        @refresh-employee-data="handleRefreshEmployeeData"
      />
      <StandarPageWithList v-if="!dashboardEnabled" title="Dashboard" />
      <EmployeeReadinessDashboard v-else />
    </div>
  </v-container>
</template>
<script>
import StandarPageWithList from "@components/common/PageHeaderWithButton.vue";
import EmployeePageHeader from "@components/common/EmployeePageHeader.vue";
import EmployeeReadinessDashboard from "@components/EmployeeReadinessDashboard/EmployeeReadinessDashboard.vue";
export default {
  name: "DashboardView",
  components: {
    StandarPageWithList,
    EmployeePageHeader,
    EmployeeReadinessDashboard,
  },
  data() {
    return {
      employeeData: null,
      loading: {
        readinessBar: false,
      },
    };
  },
  computed: {
    isNewLayoutEnabled() {
      return this.$store.getters["featureFlags/isNewDesign"];
    },
    dashboardEnabled() {
      return this.$store.getters["featureFlags/ideaMDP609"] === true;
    },
  },
  watch: {
    "$route.params.id": {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.$nextTick(() => {
            this.handleRefreshEmployeeData();
          });
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.$loader.show();
    await this.getEmployeeData();
    this.$loader.hide();
  },
  methods: {
    async getEmployeeData() {
      try {
        // Get employee data from store (should be loaded by sidebar)
        const employeeData = this.$store.getters["employeeStore/currentEmployee"];
        if (employeeData) {
          this.employeeData = employeeData;
        }
      } catch (e) {
        console.error("Failed to load employee data", e);
      }
    },
    async handleRefreshEmployeeData() {
      await this.getEmployeeData();
    },
    handleEmployeeUpdate() {
      this.employeeData = this.$store.getters["employeeStore/currentEmployee"];
    },
  },
};
</script>
<style scoped></style>
